import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import DefaultUser from "./../../assets/images/default-user.png";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileRequest } from "./../../services/authService";
import { updateUserProfile } from "../../store/actions/auth";
import BellIcon from "../../assets/images/icons/bell.png";
import {
  getUnreadNotification,
  markReadNotification,
} from "../../services/notification";
import { setNotificationCount } from "../../store/actions/ui";
import { formatDistanceToNow } from "date-fns";
import { toast } from "react-toastify";
import DecreaseNotification from "../Notifications/DecreaseNotification";
import CircleNotification from "../Notifications/CircleNotification";
import GoalNotification from "../Notifications/GoalNotification";

const Header = ({ onMenuClick }) => {
  const [arrowDown, setArrowDown] = useState(true);
  const { nickname, avatar } = useSelector((state) => state.auth);
  const { unreadNotifications } = useSelector((state) => state.ui);
  const [notifications, setNotifications] = useState([]);
  const [config, setConfig] = useState({
    show: {
      decrease: false,
      circle: false,
      goal: false,
    },
    data: {
      text: "",
      link: "",
    },
  });

  const dispatch = useDispatch();

  const init = useCallback(async () => {
    const profile = await getProfileRequest();
    dispatch(updateUserProfile(profile));
  }, [dispatch]);

  const fetchNotifications = useCallback(async () => {
    const notificationsData = await getUnreadNotification(1, 10);
    setNotifications(notificationsData.data);
    dispatch(setNotificationCount(Number(notificationsData.total)));
  }, [dispatch]);

  useEffect(() => {
    init();
    fetchNotifications();
  }, [fetchNotifications, init]);

  const resetConfig = () => {
    setConfig({
      show: {
        decrease: false,
        circle: false,
        goal: false,
      },
      data: {
        text: "",
        link: "",
      },
    });
  };

  const markRead = async (notification) => {
    if (["decrease", "goal", "circle"].includes(notification.type)) {
      setConfig({
        show: {
          decrease: notification.type === "decrease",
          circle: notification.type === "circle",
          goal: notification.type === "goal",
        },
        data: notification,
      });
    }

    const res = await markReadNotification(notification.id);
    if (res.status === "success") {
      fetchNotifications();
    } else {
      toast.error(res.message);
    }
  };

  return (
    <div className="main-header d-flex w-100 px-xl-5 px-3 pt-4 justify-content-between align-items-start">
      <div>
        <p className="h2 fw-bolder mb-0 text-primary text-capitalize">
          Hello, {nickname}!
        </p>
        <p className="text-primary my-2">
          What would you like to focus on today?
        </p>
      </div>

      <Navbar className="p-0 d-flex align-items-baseline">
        <Nav className="me-0">
          <button
            className="btn p-0 d-lg-none text-primary px-3 border-0 shadow-none"
            onClick={onMenuClick}
            aria-label="Open menu"
            style={{ outline: "none" }}
          >
            <FaBars size={22} />
          </button>
          <NavDropdown
            onToggle={() => {
              setArrowDown(!arrowDown);
              fetchNotifications();
            }}
            className="d-flex py-0 custom-dropdown-toggle px-3"
            dir=""
            align="end"
            title={
              <div className="d-flex align-items-center px-0 position-relative">
                <img
                  src={BellIcon}
                  alt="Notifications"
                  width={24}
                  height={24}
                />
                {unreadNotifications > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle 
               p-1 bg-danger border border-light rounded-circle"
                  ></span>
                )}
              </div>
            }
          >
            {notifications.length > 0 ? (
              notifications.map((notification) => (
                <NavDropdown.Item
                  key={notification.id}
                  href="#"
                  onClick={() => markRead(notification)}
                  className="px-3 py-2"
                  style={{ maxWidth: "385px" }}
                >
                  <div className="d-flex">
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                      <p
                        className={`mb-0 text-truncate ${notification.read === 0 ? "fw-semibold" : ""}`}
                      >
                        {notification.text.replace("<br/>", "")}
                      </p>
                      <small className="text-xs">
                        {formatDistanceToNow(new Date(notification.created_at))}
                      </small>
                    </div>
                  </div>
                </NavDropdown.Item>
              ))
            ) : (
              <NavDropdown.Item className="px-3 py-2">
                No unread notifications
              </NavDropdown.Item>
            )}
          </NavDropdown>

          <NavDropdown
            onToggle={() => setArrowDown(!arrowDown)}
            className="d-flex py-0 px-0 custom-dropdown-toggle"
            dir=""
            align="end"
            title={
              <div className="d-flex align-items-center px-0">
                <img
                  src={avatar || DefaultUser}
                  alt="Avatar"
                  width={40}
                  height={40}
                  className="rounded-circle"
                />
              </div>
            }
          >
            <NavDropdown.Item href="/logout">
              <p className="mb-0">Log Out</p>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar>

      <DecreaseNotification
        show={config.show.decrease}
        onHide={resetConfig}
        notification={config.data}
      />

      <CircleNotification
        show={config.show.circle}
        onHide={resetConfig}
        notification={config.data}
      />

      <GoalNotification
        show={config.show.goal}
        onHide={resetConfig}
        notification={config.data}
      />
    </div>
  );
};

export default Header;
